export function forceArray<T>(param: T | T[]): T[];
export function forceArray<T>(param: T | readonly T[]): readonly T[];
export function forceArray<T>(param: T | T[]): T[] {
  return Array.isArray(param) ? param : [param];
}
